import { envConfig } from '#constants/envConfig';
import { whenIdle } from '#utils/whenIdle';

/**
 * Когда после первого экрана смотреть на здоровье хранилища картинок.
 *
 * Модуль нарочно лёгкий: `client.tsx` берёт его статически, а сами проверки (`reportHealth` с
 * Sentry, `sendHealth` с GraphQL и мостом) подгружаются только внутри таймеров, в простое. Первый
 * кадр ставит два таймера и больше ничего не грузит и не выполняет.
 */

/**
 * Через сколько после старта смотреть, не на что ли пожаловаться в GlitchTip. Счётчикам нужно
 * время набраться: спросить сразу после запуска – значит всегда видеть нули и никогда не узнать
 * про сбои перехвата. Полминуты хватает, чтобы лента успела запросить свои картинки.
 */
export const HEALTH_REPORT_DELAY_MS = 30_000;

/**
 * Через сколько после старта отправлять снимок на бэкенд. Счётчики хранилища живут один сеанс и
 * на старте всегда нули; минуты хватает, чтобы лента запросила свои картинки и доля попаданий
 * что-то значила.
 */
export const HEALTH_SEND_DELAY_MS = 60_000;

/** Выполнить после паузы и в простое; сбой загрузки чанка или самой проверки молчит. */
const later = (delayMs: number, run: () => Promise<unknown>): void => {
  setTimeout(() => whenIdle(() => void run().catch(() => undefined)), delayMs);
};

/**
 * Запланировать оба взгляда: жалобу в GlitchTip (только если есть на что, см. `reportHealth`) и
 * снимок на бэкенд (не чаще раза в час, см. `sendHealth`). В вебе – ничего: хранилища там нет.
 * Старт этого не ждёт: таймеры ставятся и забываются.
 */
export function scheduleImageStoreHealth(): void {
  if (!envConfig.IS_NATIVE) {
    return;
  }
  later(HEALTH_REPORT_DELAY_MS, async () => {
    const { reportImageStoreTrouble } = await import('./reportHealth');
    await reportImageStoreTrouble();
  });
  later(HEALTH_SEND_DELAY_MS, async () => {
    const { sendDeviceHealth } = await import('./sendHealth');
    await sendDeviceHealth();
  });
}
